export default "__VITE_ASSET__BVPiM1LA__"